// NGO12A80GRegistration.jsx
import React from "react";

export default function NGO12A80GRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            12A and 80G Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            12A & 80G Registration for NGOs
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists NGOs and trusts in obtaining 12A and 80G
            Registration for income tax exemptions on organizational income and donor
            tax deductions under Sections 12A(b) and 80G of Income Tax Act 1961.
          </p>
          <p className="text-gray-700">
            Through Income Tax e-filing portal using Form 10A/10AB (provisional/permanent)
            and Form 10G, the process ensures tax-exempt status and donor incentives
            for charitable activities in education, healthcare, poverty alleviation.
          </p>
        </div>

        {/* Right: NGO charity community service image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="NGO charity community service for 12A 80G registration"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* PROFESSIONAL SUPPORT & DOCUMENTS SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Professional compliance support */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Professional Compliance Support by Hawkins &amp; Brooks
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks provides complete 12A/80G registration support
              through Income Tax e-filing portal for trusts, societies, and Section 8 companies.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Form 10A/10AB preparation for 12A(b) registration (tax exemption
                  on 100% income) with NGO Darpan ID, activity proofs, and DSC submission.
                </li>
                <li>
                  Form 10G application for 80G registration (50%/100% donor deduction)
                  post 12A approval with financial statements and governance compliance.
                </li>
                <li>
                  Provisional registration (3 years) conversion to permanent status
                  with audited accounts and activity continuation verification.
                </li>
                <li>
                  FCRA coordination and CSR compliance advisory for enhanced funding eligibility.
                </li>
              </ul>
            </div>
          </div>

          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for 12A & 80G Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks assists in compiling complete documentation
              required for Income Tax Department approval under both sections.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>NGO incorporation documents (Trust Deed, Society Registration, Section 8 Incorporation Certificate).</li>
                <li>PAN card of NGO, trustees/directors, and governing body members.</li>
                <li>
                  Financial statements (last 3 years audited accounts or inception
                  accounts) demonstrating charitable expenditure ≥85% of income.
                </li>
                <li>
                  Activity proofs including NGO Darpan ID, project photos, beneficiary
                  lists, annual reports, and Digital Signature Certificate (DSC).
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm specializes in NGO tax compliance with 100% success rate in
              12A/80G registrations across trusts, societies, and non-profits nationwide.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Income Tax Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete mastery of Finance Act 2020 amendments, Form 10A/10G
                  requirements, and PCIT/CIT jurisdictional procedures nationwide.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Application Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Professional e-filing portal management, DSC submission, and
                  document structuring ensuring first-time provisional/permanent approvals.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  End-to-End Professional Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete lifecycle assistance from NGO Darpan registration through
                  12A/80G approval, FCRA coordination, and 5-year renewal compliance.
                </p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col justify-center">
            <div className="bg-gray-50 border border-yellow-100 rounded-2xl p-6 shadow-sm">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Unlock Tax Benefits for Your NGO
              </h3>
              <p className="text-gray-700 mb-5">
                Connect with Hawkins &amp; Brooks to secure 12A and 80G Registration,
                enabling tax-exempt operations and donor tax deductions that enhance
                funding capacity for your charitable mission across India.
              </p>
              <div className="flex flex-wrap gap-3">
                <a
                  href="/contact"
                  className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
                >
                  Get Consultation
                </a>
                <a
                  href="tel:+919217468906"
                  className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
                >
                  Call Hawkins &amp; Brooks
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
